export default __webpack_public_path__ + "static/media/dimqaa.46d68951.png";